import { Card, Container, Placeholder, Row, Col } from 'react-bootstrap'
import PortalCard from '@/components/PortalCard'
import { useGetPortalsQuery } from '@/features/apiSliceWithPortals'
import useToastQuery from '@/hooks/useToastQuery'

export default function PortalsList() {
  const { data: portals, isFetching } = useToastQuery(useGetPortalsQuery)
  if (!portals || isFetching) return <PortalsListSkeleton />

  return (
    <Container className="py-4">
      {portals.map((portal) => (
        <PortalCard
          key={portal.id}
          portal={portal}
        />
      ))}
    </Container>
  )
}

interface PortalsListSkeletonProps {
  count?: number
}

function PortalsListSkeleton({ count = 10 }: PortalsListSkeletonProps) {
  return (
    <Container className="py-4">
      {Array.from({ length: count }).map((_, i) => (
        <Row key={i} className="mb-3 justify-content-center">
          <Col xs={12} md={10} lg={8}>
            <Card className="shadow-sm ProjectCard">
              <Card.Body>
                <Placeholder as={Card.Title} animation="wave" className="ProjectCard__Title">
                  <Placeholder xs={6} />
                </Placeholder>
                <hr className="border-secondary border-1" />
                <Placeholder as={Card.Text} animation="wave" className="PortalCard__Description">
                  <Placeholder xs={8} className="me-2" />
                  <Placeholder xs={4} />
                </Placeholder>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <Placeholder animation="wave">
                    <small className="text-muted">Created: --</small>
                  </Placeholder>
                  <Placeholder animation="wave">
                    <small className="text-muted d-flex align-items-center gap-1">
                      <i className="fa-solid fa-eye" />--
                    </small>
                  </Placeholder>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      ))}
    </Container>
  )
}
